import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

type SectionProps = {
  title: string;
  content: string;
};

export const TitleWithText = ({ title, content }: SectionProps) => (
  <Box my={3}>
    <SubHeading style={{ color: 'white' }}>{title}</SubHeading>
    <Typography style={{ color: 'white' }} variant="body2">
      {content}
    </Typography>
  </Box>
);

const SubHeading = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 700,
  '@media (min-width:1280px)': {
    fontSize: '16px',
  },
}));
